import React from 'react';
import { Empty, Tag, Tooltip } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy, faEdit, faEye, faPlus, faWarning } from '@fortawesome/free-solid-svg-icons';

//APP
import { removerAcentos } from '../../../../../../utils';

//COMPONENTS
import Input from '../../../../../../Components/CustomUi/input';
import Carregando from '../../../../../../Components/CustomUi/loading';
import ButtonCustom from '../../../../../../Components/ButtonCustom';
import { Box } from '../../../../../../Components/CustomUi/box';
import { Inline } from '../../../../../../Components/CustomUi/inline';
import { Render } from '../../../../../../Components/CustomUi/render';
import { RowItem } from '../../../../../../Components/CustomUi/table/rowItem';
import { RowTable } from '../../../../../../Components/CustomUi/table/rowTable';
import { BodyTable } from '../../../../../../Components/CustomUi/table/bodyTable';
import { HeaderTable } from '../../../../../../Components/CustomUi/table/headerTable';
import { DeleteButton } from '../../../../../../Components/CustomUi/deleteButton';
import { ItensPerUserLogged } from '../../../../../../services/login/permissaoUsuarioLoado';

//PROPS
interface Props {
  loading: boolean
  list_insumos: any[]
  deletar: Function
  abrir: Function
  editar: Function
  clone: Function
  permissions: ItensPerUserLogged
  setPagination: React.Dispatch<React.SetStateAction<number>>
  page: number
  setPage: React.Dispatch<React.SetStateAction<number>>
  buscarTabela: string
  setBuscarTabela: React.Dispatch<React.SetStateAction<string>>
  total: number
  confirmar_exclusao: boolean
  setConfirmar_exclusao: React.Dispatch<React.SetStateAction<boolean>>
  id_item_atual: number
  setId_item_atual: React.Dispatch<React.SetStateAction<number>>
  nome_item_atual: string
  setNome_item_atual: React.Dispatch<React.SetStateAction<string>>
  fake_loading: boolean
  setFake_loading: React.Dispatch<React.SetStateAction<boolean>>
}

export const TabelaInsumos: React.FC<Props> = ({
  list_insumos,
  loading,
  deletar,
  abrir,
  setPagination,
  editar,
  clone,
  page,
  setPage,
  buscarTabela,
  setBuscarTabela,
  total,
  confirmar_exclusao,
  setConfirmar_exclusao,
  id_item_atual,
  setId_item_atual,
  nome_item_atual,
  setNome_item_atual,
  fake_loading,
  setFake_loading,
  permissions
}) => {

  function buscarPatrimonios(buscar_nome: string) {
    const palavraSemAcentos = removerAcentos(buscar_nome)
    return function (item) {
      const nomeSemAcentos = removerAcentos(String(item?.nome))
      return nomeSemAcentos.toLowerCase().includes(palavraSemAcentos.toLowerCase()) || !buscar_nome
    }
  }

  return (
    <Box style={{ height: 'calc(100vh - 170px)', border: 'none' }} padding={0} borderless>
      {/* <TitleH2>Lista de patrimônios</TitleH2> */}

      <Inline alignItems='center'>
        <Input placeholder='Buscar insumos por nome, fabricante, classe agronômica, composição ou cultura' value={buscarTabela} onChange={setBuscarTabela} />
        <ButtonCustom icon={<FontAwesomeIcon icon={faPlus} />} onClick={abrir}>
          Novo
        </ButtonCustom>
      </Inline>

      <HeaderTable
        itens={[
          { valor: 'Nome', width: 'calc(100% - 962px)' },
          { valor: 'Fabricante', width: '150px' },
          { valor: 'Classe agronômica', width: '170px' },
          { valor: 'Composição', width: '171px' },
          { valor: 'Culturas', width: '242px' },
          { valor: 'Ações', width: '228px' },
        ]}
      />

      <BodyTable
        paginate={total}
        onChangeItensPage={setPagination}
        onChangePage={setPage}
        current_page={page}
        setCurrent_page={setPage}
        style={{
          height: 'calc(100vh - 170px)',
          // height: (list_insumos ?? []).length < 8 && 'calc(100vh - 170px)',
          position: 'relative',
          overflowX: 'hidden',
          overflowY: 'scroll',
          marginTop: -10,
        }}
      >
        <Render condition={!loading}>
          {(list_insumos ?? [])
            // .filter(buscarPatrimonios(buscarTabela))
            .map(({ cod, nome, fabricante_nome, classe_agronomica_nome, composicao, aplicacoes, cod_classe_agronomica }, index) => {
              const possui_cla_agro_diferente = composicao.some(i => i.ativo?.[0].cod_classe_agronomica !== cod_classe_agronomica && !isNaN(i.ativo?.[0].cod_classe_agronomica))
              return (
                <RowTable key={cod} onDoubleClick={() => editar(cod)} style={{ height: 'auto' }}>
                  <RowItem fontSize={13} width={'calc(100% - 956px)'} gap={5}>
                    {possui_cla_agro_diferente && (
                      <Tooltip title='Há ativos nesta composição com classe agronômica diferente da do insumo.'>
                        <FontAwesomeIcon icon={faWarning} color='orange' style={{ marginTop: 3 }} />
                      </Tooltip>
                    )}
                    {nome}
                  </RowItem>
                  <RowItem fontSize={13} width={'150px'}>
                    {fabricante_nome}
                  </RowItem>
                  <RowItem fontSize={13} width={'170px'}>
                    {classe_agronomica_nome}
                  </RowItem>
                  <RowItem
                    fontSize={13}
                    width={'170px'}
                    style={{
                      display: 'flex',
                      flexWrap: 'wrap',
                      justifyContent: 'flex-start',
                      alignContent: 'center',
                    }}
                  >
                    {composicao?.map((tag) => {
                      const clas_agr_diferente = (tag?.ativo?.[0]?.cod_classe_agronomica !== cod_classe_agronomica) && !isNaN(tag.ativo?.[0].cod_classe_agronomica)
                      return (
                        <Tag color={clas_agr_diferente ? 'orange' : 'green'} key={tag.cod} style={{ margin: 5, fontSize: '10px', whiteSpace: 'normal' }}>
                          <div style={{ display: 'flex', gap: 5, alignItems: 'center' }}>
                            {clas_agr_diferente && (
                              <Tooltip title='O ativo desta composição possui classe agronômica diferente da do insumo.'>
                                <FontAwesomeIcon icon={faWarning} color='orange' style={{ marginTop: -1 }} />
                              </Tooltip>
                            )}

                            {tag.ativo_nome.toUpperCase()}
                          </div>
                        </Tag>
                      )
                    })}
                  </RowItem>
                  <RowItem
                    fontSize={13}
                    width={'243px'}
                    style={{
                      display: 'flex',
                      flexWrap: 'wrap',
                      justifyContent: 'flex-start',
                      alignContent: 'center',
                    }}
                  >
                    {aplicacoes?.map((tag) => {
                      return (
                        <Tag color='green' key={tag.cod} style={{ margin: 5, fontSize: '10px', whiteSpace: 'normal' }}>
                          {tag.cultura_nome.toUpperCase()}
                        </Tag>
                      )
                    })}
                  </RowItem>
                  <RowItem width={'223px'} gap={10}>
                    <DeleteButton
                      open={confirmar_exclusao && id_item_atual === cod}
                      trigger={setConfirmar_exclusao}
                      onTrigger={() => {
                        setId_item_atual(cod)
                        setNome_item_atual(nome)
                      }}
                      loading={fake_loading}
                      message={`o item ${nome} será excluido!`}
                      deleteds={[nome]}
                      onDelete={() => {
                        deletar(cod)
                      }}
                      disabled={fake_loading}
                      hidden={permissions?.exclusao === 0}
                      typeButtonTrigger='tertiary'
                      dangerButtonCancel
                    />
                    <ButtonCustom
                      icon={<FontAwesomeIcon icon={faCopy} />}
                      type='secondary'
                      onClick={() => {
                        clone(cod, false)
                      }}
                      disabled={permissions?.acesso === 0 && permissions?.alteracao === 0}
                    />
                    <ButtonCustom
                      icon={<FontAwesomeIcon icon={permissions?.acesso === 1 ? faEye : faEdit} />}
                      onClick={() => {
                        editar(cod)
                      }}
                      disabled={permissions?.acesso === 0 && permissions?.alteracao === 0}
                    >
                      {permissions?.acesso === 1 ? 'Ver' : 'Editar'}
                    </ButtonCustom>
                  </RowItem>
                </RowTable>
              )
            })}
        </Render>

        <Render condition={list_insumos.length === 0 && !loading}>
          {buscarTabela === '' ? (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description={<> Nenhum registro disponível!</>}
            />
          ) : (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description={
                <>
                  {' '}
                  <b>'{buscarTabela}'</b> não encontrado!
                </>
              }
            />
          )}
        </Render>

        <Render condition={loading}>
          <Carregando
            animation
            legenda='Carregando insumos...'
            justifyContent='center'
            height={400}
            size='default'
          />
        </Render>
      </BodyTable>
    </Box>
  )
}